<template>
  <div id="pageDealerUsers">
    <v-card class="mb-5">
      <v-toolbar color="primary" dark flat>
        <v-icon class="mr-2">mdi-account</v-icon>
        <v-toolbar-title>Lista de usuarios del dealer</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text class="pa-0">
        <v-data-table
          :headers="headers"
          :items="dealerUsers"
          :options.sync="pagination"
          :loading="loading"
          :footer-props="footer"
          class="elevation-1"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td style="white-space: nowrap; width: 1%;">{{ item.name }}</td>
              <td style="white-space: nowrap; width: 1%;">{{ item.email }}</td>
              <td style="white-space: nowrap; width: 1%;">{{ item.phone }}</td>
              <td style="white-space: nowrap; width: 1%;">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn v-show="item.status" depressed dark icon color="red" @click="disableUser(item)" v-on="on">
                      <v-icon size="20">mdi-block-helper</v-icon>
                    </v-btn>
                  </template>
                  <span>Deshabilitar</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn v-show="!item.status" depressed dark icon color="green" @click="enableUser(item)" v-on="on">
                      <v-icon size="20">mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Habilitar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import UserService from '../../services/UserService'

const STATUS_DISABLED = 0
const STATUS_ENABLED = 10

export default {
  props: {
    dealerId: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    // datatable
    loading: false,
    totalItems: 0,

    headers: [
      { text: 'Nombre', value: 'name' },
      { text: 'Email', value: 'email' },
      { text: 'Teléfono', value: 'phone' },
      { text: '', value: 'action', sortable: false, align: 'right' }
    ],

    footer: {
      itemsPerPageOptions: [10, 20, 30, 40, 50]
    },

    dealerUsers: [],
    pagination: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false
    }
  }),

  async created () {
    this.loadUsers()
  },

  methods: {
    async loadUsers () {
      this.loading = true
      try {
        const response = await UserService.get({
          'filter[dealerId]': this.dealerId,
          page: this.pagination.page,
          perPage: this.pagination.itemsPerPage,
          sortBy: this.pagination.sortBy,
          sortDesc: this.pagination.sortDesc
        })
        this.dealerUsers = response.data.data
        this.totalItems = response.data._meta.totalCount
      } catch (error) {
        console.error(error)
        this.$toast.error('Ocurrió un problema al intentar obtener la lista de usuarios')
      } finally {
        this.loading = false
      }
    },

    disableUser (item) {
      this.$confirm('¿Está seguro que desea deshabilitar el usuario?').then(result => {
        if (result) {
          this.loading = true
          item.status = STATUS_DISABLED
          this.$store.dispatch('DISABLE_USER', item).then(() => {
            this.loading = false
            this.$toast.success('El usuario ha sido deshabilitado satisfactoriamente')
          }).catch(error => {
            console.error(error)
            this.$toast.error('Ocurrió un problema al intentar deshabilitar el usuario')
            this.loading = false
          })
        }
      })
    },

    enableUser (item) {
      this.$confirm('¿Está seguro que desea habilitar el usuario?').then(result => {
        if (result) {
          this.loading = true
          item.status = STATUS_ENABLED
          this.$store.dispatch('ENABLE_USER', item).then(() => {
            this.loading = false
            this.$toast.success('El usuario ha sido habilitado satisfactoriamente')
          }).catch(error => {
            console.error(error)
            this.$toast.error('Ocurrió un problema al intentar habilitar el usuario')
            this.loading = false
          })
        }
      })
    }
  },

  watch: {
    pagination: {
      handler () {
        this.loadUsers()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
</style>
